import { useEffect, useState } from "react"
import { Popover, Typography, Badge } from "@mui/material"
import { useApiService } from "../../hooks/Api/useApiService"
import { useNavigate } from "react-router-dom"
import Icn from "../SharieIcn/SharieIcn"
import useTranslationSharie from "../../hooks/Language/useTranslation"
import UserSection from "../../Marketplace/UserSection/UserSection"
import { useSocket } from "../../hooks/Utils/Socket/SocketManager"
import PeopleGradientIcon from "../PeopleGradientIcon"

const UsersPopup = (props) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [users, setUsers] = useState([])
  const { postData } = useApiService()
  const navigate = useNavigate()
  const t = useTranslationSharie()
  const socket = useSocket()

  useEffect(() => {
    try {
      props.skill.name &&
        postData("users/getlearningusers", {
          skill_name: props.skill.name,
        }).then((data) => {
          setUsers(
            data?.users?.filter(
              (user, index, self) =>
                index === self.findIndex((u) => u.id === user.id && u.progress !== "finished")
            )
          )
        })
    } catch (error) {
      console.error("Error getting users:", error)
    }
  }, [])

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }
  const sendNotification = (type) => {
    try {
      socket?.emit("send_notification", {
        toUserId: props.skill.user_id,
        skill_name: props.skill.name,
        from: localStorage.getItem("user"),
        to: props.skill.user_name,
        type: type,
      })
      postData("sharie/addnotification", {
        skill_name: props.skill.name,
        from: localStorage.getItem("user"),
        type: type,
      }).then((data) => {})
    } catch (error) {
      console.error("Error sending notification:", error)
    }
  }
  const handleAvatarClick = (user_name) => {
    sendNotification("view profile")
    navigate("/profile", {
      state: { user_name: user_name, editable: user_name === props.skill.user_name },
    })
  }
  return (
    <Badge
      badgeContent={users?.length || 0}
      overlap='circular'
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      sx={{
        "& .MuiBadge-badge": {
          backgroundColor: "#795548", // rich brown
          color: "text.primary",
        },
      }}
    >
      <Icn tooltip='Learning This' onClick={handleClick} icon={<PeopleGradientIcon />} />

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        slotProps={{
          paper: {
            sx: {
              borderRadius: "0.8rem",
            },
          },
        }}
      >
        {users?.length === 0 && (
          <Typography padding={"1rem"}>{t("No One Is Learning This Yet")}</Typography>
        )}
        {users?.map((user, index) => (
          <UserSection key={index} user={user} />
        ))}
      </Popover>
    </Badge>
  )
}

export default UsersPopup
